// Width of a line of SVG text in viewBox units, measured with the font the page
// actually renders (Poppins, via the body's font-family), so boxes drawn around
// text are sized to the text instead of guessed. Falls back to a conservative
// per-character estimate where no canvas is available (tests, SSR).
let ctx = null;

export function measureText(text, fontSize, fontWeight = 400) {
  if (!text) return 0;
  try {
    if (!ctx) ctx = document.createElement("canvas").getContext("2d");
    const family = getComputedStyle(document.body).fontFamily || "Poppins, sans-serif";
    ctx.font = `${fontWeight} ${fontSize}px ${family}`;
    return ctx.measureText(text).width;
  } catch (e) {
    return text.length * fontSize * 0.62;
  }
}

// Splits text into as few lines as needed to fit maxWidth, breaking at spaces.
export function wrapText(text, fontSize, fontWeight, maxWidth) {
  const words = text.split(" ");
  const lines = [];
  let line = "";
  words.forEach((w) => {
    const next = line ? `${line} ${w}` : w;
    if (line && measureText(next, fontSize, fontWeight) > maxWidth) {
      lines.push(line);
      line = w;
    } else {
      line = next;
    }
  });
  if (line) lines.push(line);
  return lines;
}
